import { Component } from '@angular/core';

@Component({
    selector: 'gl-add-notifications-page',
    templateUrl: './add-notifications-page.component.html',
    styleUrls: ['./add-notifications-page.component.scss']
})
export class AddNotificationsPageComponent {}
